const priceFormatter = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const priceFormatterCompact = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const formatPrice = price => priceFormatter.format(price);

export const formatPriceCompact = price => priceFormatterCompact.format(price);

export const PRICE_LEVEL_CLASS = {
  cheap: 'udp-day--cheap',
  normal: 'udp-day--normal',
  expensive: 'udp-day--expensive',
};
